<template>
  <div>
    <div class="block">
      <div class="title-container">
        <h3>Ophalen</h3>
        <button class="white-pill-s" @click="$emit('goTo')">
          Bewerken
        </button>
      </div>
      <div>
        <span
          class="error-text pointer"
          @click="$emit('goTo')"
          v-if="!order.pickUpDate.value"
          >Datum ontbreekt nog, klik hier.</span
        >
        <span v-else-if="order.pickUpDate.day == 'spoed'">
          Spoed
        </span>
        <span v-else class="capitalize">
          {{ order.pickUpDate.day }} {{ pickUpDate }}
        </span>
      </div>
    </div>

    <div class="block">
      <div class="title-container">
        <h3 class="system-text">
          Ophaaladres
        </h3>
      </div>
      <p class="error-text pointer" v-if="!order.pickUpAddress.company">
        <span @click="$emit('goTo')"
          >Ophaaladres is niet compleet, klik hier.</span
        >
      </p>
      <p v-else>
        {{ order.pickUpAddress.company }}<br />
        <span
          class="error-text pointer"
          v-if="!order.pickUpAddress.department && custom.department.required"
          @click="$emit('goTo')"
        >
          {{ custom.department.label ? custom.department.label : 'Afdeling' }}
          is verplicht, klik hier.<br />
        </span>

        <span v-if="order.pickUpAddress.department"
          >{{ custom.department.label ? custom.department.label : 'Afdeling' }}
          {{ order.pickUpAddress.department }}<br
        /></span>
        <span v-if="order.pickUpAddress.name"
          >t.a.v. {{ order.pickUpAddress.name }}<br
        /></span>
        {{ order.pickUpAddress.street }}
        {{ order.pickUpAddress.number }}
        {{ order.pickUpAddress.addition }}<br />
        {{ order.pickUpAddress.zipCode }}
        {{ order.pickUpAddress.city }}
      </p>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns'

export default {
  props: ['order', 'orderType'],
  data() {
    return {}
  },
  methods: {},
  computed: {
    custom() {
      return this.rootStore.theme.customFields
    },
    pickUpDate() {
      return format(new Date(this.order.pickUpDate.value), 'dd-MM-yyyy')
    }
  },
  created() {
    if (
      !this.order.pickUpDate.value ||
      !this.order.pickUpAddress.company ||
      (!this.order.pickUpAddress.department && this.custom.department.required)
    ) {
      this.$emit('addError', 'pickupError')
    } else {
      this.$emit('removeError', 'pickupError')
    }
  }
}
</script>

<style lang="scss" scoped></style>
